export default __webpack_public_path__ + "static/media/cc2021 (1).96520b60.jpg";